// Libraries
import axios from 'axios';

// Services and Contexts
import { translateToLanguage } from '../services/language';

// Send emails to customer and to main office
const sendEmail = async (data) => {
  const statusOffice = await sendEmailToOffice(data);
  const statusClient = await sendEmailToClient(data);

  return [statusClient, statusOffice];
};

const sendEmailToOffice = async ({ language, ratings, userRatings, user, questions }) => {
  const API_ENDPOINT = '/api/email';
  const config = {};

  const ProductTableData = [];
  userRatings.byCategory.forEach((categoryRating, categoryIndex) => {
    ProductTableData.push({
      Category: ratings.byCategory.diagram.colLabels[categoryIndex]['en'],
      Rating: categoryRating,
      Product: ratings.byCategory.levels[categoryIndex].product[categoryRating]['en']
    });
  });

  const QuestionTableData = questions.map((category) => ({
    Category: category.category.en,
    Questions: category.questions.map((question) => ({
      Question: question.en,
      Answer: question.answer === true ? 'YES' : question.answer === false ? 'NO' : ''
    }))
  }));

  const payload = {
    Destination: 'office',
    TemplateAlias: 'dma_office_template',
    TemplateModel: {
      // Introduction Message Header
      Introduction: {
        Title: 'A new DMA report was submitted.',
        Image: 'intellisense_io_digital_mine.jpg'
      },

      // User Details
      User: {
        Name: user.name || 'Undisclosed',
        Company: user.company || 'Undisclosed',
        Operation: user.operation || 'Undisclosed',
        Position: user.position || 'Undisclosed',
        Email: user.email
      },

      // Overall Rating Section
      OverallRating: {
        Title: 'Overall Rating',
        RatingIntro: translateToLanguage('SCREEN_RESULTS_OVERALL_RATING_DESCRIPTION', 'en'),
        RatingName: ratings.overall.levels[userRatings.overall].name['en'],
        Description: ratings.overall.levels[userRatings.overall].description['en'],
        Recommendation: ratings.overall.levels[userRatings.overall].recommendations['en'],
        Image: `gr_gmg_${userRatings.overall}_en.png`
      },

      // Product Recommendation Section
      ProductRecommendation:
        userRatings.overall > 0
          ? {
              Title: translateToLanguage('SCREEN_RESULTS_PRODUCT_RECOMMENDATION_TITLE', 'en'),
              Description: translateToLanguage(
                'SCREEN_RESULTS_PRODUCT_RECOMMENDATION_DESCRIPTION',
                'en'
              ),
              TableHeader: {
                Category: translateToLanguage(
                  'SCREEN_RESULTS_PRODUCT_RECOMMENDATION_CATEGORY',
                  'en'
                ),
                Rating: translateToLanguage('SCREEN_RESULTS_PRODUCT_RECOMMENDATION_LEVEL', 'en'),
                Product: translateToLanguage('SCREEN_RESULTS_PRODUCT_RECOMMENDATION_PRODUCT', 'en')
              },
              TableData: ProductTableData.filter((Category) => Category.Rating > 0)
            }
          : {},

      // Product Recommendation Section
      Questionnaire: {
        Categories: QuestionTableData
      }
    }
  };

  try {
    const response = await axios.post(API_ENDPOINT, payload, config);
    return response.status;
  } catch (error) {
    return error.response.status;
  }
};

const sendEmailToClient = async ({ language, ratings, userRatings, user, questions }) => {
  const API_ENDPOINT = '/api/email';
  const config = {};

  const ProductTableData = [];
  userRatings.byCategory.forEach((categoryRating, categoryIndex) => {
    ProductTableData.push({
      Category: ratings.byCategory.diagram.colLabels[categoryIndex][language],
      Rating: categoryRating,
      Product: ratings.byCategory.levels[categoryIndex].product[categoryRating][language]
    });
  });

  const payload = {
    Destination: 'customer',
    To: user.email,
    TemplateAlias: 'dma_client_template',
    TemplateModel: {
      // Introduction Message Header
      Introduction: {
        Title: translateToLanguage('EMAIL_CLIENT_TITLE', language),
        Text: translateToLanguage('EMAIL_CLIENT_INTRODUCTION', language).map((line) => ({
          line
        })),
        Image: 'intellisense_io_digital_mine.jpg'
      },

      // Overall Rating Section
      OverallRating: {
        Title: translateToLanguage('SCREEN_RESULTS_OVERALL_RATING_TITLE', language),
        RatingIntro: translateToLanguage('SCREEN_RESULTS_OVERALL_RATING_DESCRIPTION', language),
        RatingName: ratings.overall.levels[userRatings.overall].name[language],
        Description: ratings.overall.levels[userRatings.overall].description[language],
        Recommendation: ratings.overall.levels[userRatings.overall].recommendations[language],
        Image: `gr_gmg_${userRatings.overall}_${language}.png`
      },

      // Product Recommendation Section
      ProductRecommendation:
        userRatings.overall > 0
          ? {
              Title: translateToLanguage('SCREEN_RESULTS_PRODUCT_RECOMMENDATION_TITLE', language),
              Description: translateToLanguage(
                'SCREEN_RESULTS_PRODUCT_RECOMMENDATION_DESCRIPTION',
                language
              ),
              TableHeader: {
                Category: translateToLanguage(
                  'SCREEN_RESULTS_PRODUCT_RECOMMENDATION_CATEGORY',
                  language
                ),
                Rating: translateToLanguage(
                  'SCREEN_RESULTS_PRODUCT_RECOMMENDATION_LEVEL',
                  language
                ),
                Product: translateToLanguage(
                  'SCREEN_RESULTS_PRODUCT_RECOMMENDATION_PRODUCT',
                  language
                )
              },
              TableData: ProductTableData.filter((Category) => Category.Rating > 0)
            }
          : {},

      // Message footer and call to Action
      Conclusion: {
        Text: translateToLanguage('EMAIL_CLIENT_CONCLUSION', language).map((line) => ({
          line
        })),
        ActionUrl: 'https://intellisense.io',
        ActionLabel: translateToLanguage('EMAIL_CLIENT_ACTION_BUTTON', language)
      }
    }
  };

  try {
    const response = await axios.post(API_ENDPOINT, payload, config);
    return response.status;
  } catch (error) {
    return error.response.status;
  }
};

export { sendEmail };
